<template>

	<div>

		<section class="outer-pad">

			<Table 
				:headings="headings" 
				:items="itemsProcessed" 
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:sorted="table.sorted"
				:searchSetup="searchSetup" 
				name="admin-projects"
				emptyLabel="No projects were found"
				:loading="!fetched"
				loadingText="Fetching projects..."
				@pagination="pagination"
				@sort="sort"
				@search="search"
				@moveProject="moveProject"
			/>

		</section>

		<div class="settings modal" v-if="showTransferOverlay">

			<div class="modal-wrap">

				<div class="modal-inner">

					<h2 class="modal-title">Transfer {{moveProjectSettings.name}}<span class="close" @click="closeMoveProject">X</span></h2>

					<div class="modal-inner-scroll">

						<form class="form normal" @submit.prevent="">

							<FormInput type="email" label="Enter The Users Email To Transfer To" v-model="userToMoveTo" placeholder="" :required="false" />

							<v-select 
				                placeholder="Google Account"
				                v-model="googleAccount" 
				                :options="googleAccountList" 
				                :reduce="option => option._id"
				                v-if="googleAccountList.length>0"
				            ></v-select>

							<span 
								class="large-button" 
								@click="completeMoveProject" 
								v-html="'Transfer ' + moveProjectSettings.name"
								v-if="userToMoveTo!==''&&( googleAccountList.length === 0 || googleAccount !== null ) && ok2go"
							/>

						</form>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex'
import ApiService from './../../services/api.service'
import Table from './../../components/Table.vue'
import TableIcon from './../../components/Display/TableIcon.vue'
import FormInput from './../../components/Form/Input.vue'
export default {
	name: 'AdminProjects',
	components: {
		Table,
		FormInput
	},
	data() {
		return {
			fetched: false,
			showHeadings:{},
			table: {
				items:[],
				page: 1,
				pages: 1,
				sorted: { name: 1 },
				search: {}
			},
			googleAccountList: [],
			googleAccount: null,
			userToMoveTo: '',
			ok2go: true,
			showTransferOverlay: false,
			moveProjectSettings: {
				_id: null,
				name: ''
			},
			statuses: { queued: "Queued", 'in-progress': "In Progress", 'finalizing': "Finalizing", 'out-of-credits': "Out Of Credits", complete: 'Completed' }
		}
	},
	computed: {

		searchSetup () {

			let searchSetup = { 
				searchText: { type: 'text', placeholder: '', showLabel: 'Search URL' },
				email: { type: 'text', showLabel: 'Filter By User', placeholder: 'Enter their email' }
			};

			return searchSetup;

		},
		headings () {

			let headings = {
				name: { value: 'Name', alignHeading: 'left', alignCell: 'left', sort: -1 }, 
				url: { value: 'URL', alignHeading: 'left', alignCell: 'left', sort: 1 },
				user: { value: 'User Email', alignHeading: 'left', alignCell: 'left', sort: 1 },
				move: { value: 'Move', component: TableIcon, event: 'moveProject', hideHeadingDesktop: true }
			};

			return headings;

		},

		itemsProcessed() {

			let items = [];

			this.table.items.forEach ( function (item) {

				if ( item.status !== '' ) {

					let c = 'green', t = '';

					switch ( item.status ) {

						case 'new': 
						case 'added': 
						case 'queued': 
							c = 'red';
							t = 'Queued';
							break;
						case 'in-progress': 
						case 'in-progress-rescrape':
							c = 'orange'; 
							t = 'In Progress';
							break;
						case 'finalizing': 
							c = 'orange'; 
							t = 'Finalizing';
							break;
						case 'zero-credits': 
							c = 'red'; 
							t = 'Out Of Credits';
							break;
						case 'complete': 
						case 'completed': 
							c = 'green'; 
							t = 'Completed';
							break;

					}

					if ( t !== '' ) item.statusText = { value: [{ colour: c, value: t }]};

				}

				items.push(item);

			}.bind(this));

			return items;

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		closeMoveProject () {
			
			this.showTransferOverlay = false;

		},

		completeMoveProject () {

			this.$dialog
				.confirm( "Are you sure you want to transfer "+this.moveProjectSettings.name+"?", { okText: 'Do It!', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText('One moment...');

					let vars = this.googleAccount ? { googleAccount: this.googleAccount } : {};

					ApiService.post( 'admin/projects/move/'+this.moveProjectSettings._id+'/' + this.userToMoveTo, vars )
					.then( function( info ) {

						this.updateLoadingText();

						if ( typeof info.data.list !== 'undefined' ) {

							if ( info.data.list.length === 0 ) {

								this.$snotify.error("You must add a google account to the new user that has access to the domain in this project.", 'Trasfer Project');
								Vue.set( this, 'ok2go', false );

							}
							else {

								this.$snotify.error("You must select a google account that is associated with the new user, this account must have access to the domain in this project!!", 'Trasfer Project');
								Vue.set( this, 'googleAccountList', info.data.list );
								Vue.set( this, 'ok2go', true );

							}

						}
						else {

							this.submitSearch();
							this.closeMoveProject ();
							this.$snotify.success('Complete', 'Transfer Project');

						}

					}.bind(this))
					.catch( function(err) {

						this.updateLoadingText();

						let info = err.response.data.error;

						if ( typeof info.list !== 'undefined' ) {

							if ( info.list.length === 0 ) {

								this.$snotify.error("You must add a google account to the new user that has access to the domain in this project.", 'Trasfer Project');
								Vue.set( this, 'ok2go', true );

							}
							else {

								this.$snotify.error("You must select a google account that is associated with the new user, this account must have access to the domain in this project!!", 'Trasfer Project');
								Vue.set( this, 'googleAccountList', info.data.list );
								Vue.set( this, 'ok2go', true );

							}

						}
						else {

							this.$snotify.error(err.response.data.error, 'Transfer Project');

						}

					}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		moveProject ({_id,name}) {

			this.googleAccountList = [];
			this.ok2go = true;
			this.googleAccount = null;
			this.showTransferOverlay = true;
			this.moveProjectSettings._id = _id;
			this.moveProjectSettings.name = name;

		},

		dropdown(type) {

			let items = [];

			Object.keys( this[type] ).forEach ( function ( name ) {

				items.push( { value: name, label: this[type][name] } );

			}.bind(this));

			return items;

		},

		sort(info) {

			Vue.set( this.table, 'sorted', info );
			Vue.set( this.table, 'page', 1 );
			if ( info.init ) { delete this.table.sorted.init; return; }
			this.submitSearch();

		},

		search(info) {

			this.table.page = 1;
			this.table.search = info;
			this.submitSearch();

		},

		pagination(info) {

			this.table.page = info.page;
			this.submitSearch();

		},

		submitSearch (csv) {

			let vars = { page: this.table.page, search: this.table.search, sorted: this.table.sorted };

			ApiService.post( 'admin/projects', vars )
	        .then( function( info ) {

	            let tableInfo = this.table;

				tableInfo.items = info.data.items;
				tableInfo.count = info.data.count;
				tableInfo.pages = info.data.pages;
				tableInfo.page = info.data.page;

				if ( info.sorted ) {

					tableInfo.sorted = info.sorted;

				}

				this.fetched = true;

				Vue.set(this, 'table', tableInfo);

	        }.bind(this))
	        .catch( function(err) {
	            console.log(err);
	        });

		}
		
	},
	created() {

		this.submitSearch();

	}
}
</script>
